import * as def from '@/definitions'
import { TextInfo } from '@/utilityModels/textInfo'
import { Layer } from './layer';
import { ExTextLayer } from './exTextLayer';
import { ArrayHelper } from '@/helper/arrayHelper';
import { StringHelper } from '@/helper/stringHelper';
import { UuidHelper } from '@/helper/uuidHelper';

// 円周文字レイヤー
export class CircleTextLayer extends ExTextLayer
{
    public get layerType() : string { return "circleText"; }

    // 行間(%)
    private _lineSpacing : number = 120;
    public get lineSpacing() : number { return this._lineSpacing; }
    public set lineSpacing(lineSpacing) { this._lineSpacing = lineSpacing; }
    
    // 文字方向
    // 0: 横書き
    // 1: 縦書き
    private _textOrientation : number = 0;
    public get textOrientation() : number { return this._textOrientation; }
    public set textOrientation(textOrientation : number ) { this._textOrientation = textOrientation; }

    // 水平揃え
    // 0: 左
    // 1: 中央
    // 2: 右
    private _horizontalAlignment : number = 1;
    public get horizontalAlignment() : number { return this._horizontalAlignment; }
    public set horizontalAlignment(horizontalAlignment : number) { this._horizontalAlignment = horizontalAlignment; }

    // 向き
    // 0: 外向き
    // 1: 内向き
    private _direction : number = 0;
    public get direction() { return this._direction; }
    public set direction(direction) { this._direction = direction; }

    // 作成
    public static create(text : string, x : number, y : number, width : number, height : number) : CircleTextLayer
    {
        var layer = new CircleTextLayer();
        layer.text = text;
        
        layer.x = x;
        layer.y = y;
        layer.width = width;
        layer.height = height;
        layer.insertionId = UuidHelper.getUuid();

        // 初期文法設定
        layer.setWholeTextInfo(new TextInfo());
        
        return layer;
    }

    // 複製
    public clone()
    {
        var cloned = new CircleTextLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : CircleTextLayer)
    {
        layer.lineSpacing = this._lineSpacing;
        layer.textOrientation = this._textOrientation;
        layer.horizontalAlignment = this._horizontalAlignment;
        layer.direction = this._direction;
        
        super.cloneParameter(layer);
    }
    

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.lineSpacing = this._lineSpacing;
        jsonObject.textOrientation = this._textOrientation;
        jsonObject.horizontalAlignment = this._horizontalAlignment;
        jsonObject.direction = this._direction;

        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : CircleTextLayer
    {
        var layer = new CircleTextLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.lineSpacing != null) { this._lineSpacing = jsonData.lineSpacing; }
        if(jsonData.textOrientation != null) { this._textOrientation = jsonData.textOrientation; }
        if(jsonData.horizontalAlignment != null) { this._horizontalAlignment = jsonData.horizontalAlignment; }
        if(jsonData.direction != null) { this._direction = jsonData.direction; }

        super.loadParameterFromJson(jsonData);
    }
}